import { useQuery } from "@tanstack/react-query";
import { apiService } from "../services/api";
import { QueryKeys } from "../enums/queryKeys";
import { FREE_FALLBACK, canUsePaidFeature } from "./subscription.utils";

export const useSubscription = () => {
  const { data, isLoading, error, refetch } = useQuery({
    queryKey: QueryKeys.SUBSCRIPTION,
    queryFn: async () => {
      const response = await apiService.getSubscriptionStatus();
      if (!response.success) throw new Error("Failed to load subscription");
      return response.data;
    },
    staleTime: 5 * 60 * 1000,
    retry: false,
  });

  const subscription = error ? FREE_FALLBACK : data ?? null;
  const unlimitedAccess = subscription?.unlimitedAccess === true;

  return {
    subscription,
    loading: isLoading,
    error,
    canCustomize: canUsePaidFeature(subscription, unlimitedAccess),
    canShare: canUsePaidFeature(subscription, unlimitedAccess),
    isFreePlan: subscription?.planType === "FREE" || !subscription,
    refresh: refetch,
    unlimitedAccess,
  };
};
